import { FeedbackArea } from './schema/FeedbackAreas';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import { isFeatureEnabled } from 'owa-feature-flags';

const getFeedbackConfig = (): FeedbackArea[] =>
    [
        {
            displayName: 'Mail',
            baseEmailAddresses: ['outlookwebfeedback@microsoft.com'],
            defaultWorkloads: OwaWorkload.Mail,
            subAreas: [
                {
                    displayName: 'Folders',
                    additionalEmailAddresses: ['owatriage@microsoft.com'],
                    workloads: OwaWorkload.Mail,
                },
                {
                    displayName: 'List view',
                    additionalEmailAddresses: ['owatriage@microsoft.com'],
                    workloads: OwaWorkload.Mail,
                },
                {
                    displayName: 'Triage actions',
                    additionalEmailAddresses: ['owatriage@microsoft.com'],
                    workloads: OwaWorkload.Mail,
                },
                {
                    displayName: 'Reading pane',
                    additionalEmailAddresses: [
                        'owareadingpane@service.microsoft.com',
                        'phloh@microsoft.com',
                    ],
                },
                {
                    displayName: 'Compose',
                    additionalEmailAddresses: ['owacompeng@microsoft.com', 'phloh@microsoft.com'],
                },
            ],
        },
        {
            displayName: 'Calendar',
            baseEmailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'calendarreactfeedback@service.microsoft.com',
            ],
            defaultWorkloads: OwaWorkload.Calendar,
            subAreas: [
                { displayName: 'Adding an event', workloads: OwaWorkload.Calendar },
                { displayName: 'Creating a meeting', workloads: OwaWorkload.Calendar },
                { displayName: 'Scheduling', workloads: OwaWorkload.Calendar },
                {
                    displayName: 'Adding locations, rooms, or Skype',
                    workloads: OwaWorkload.Calendar,
                },
                {
                    displayName: 'Events from email (flights, packages ...)',
                    workloads: OwaWorkload.Calendar,
                },
                { displayName: 'Calendar sharing', workloads: OwaWorkload.Calendar },
                { displayName: 'Calendar views', workloads: OwaWorkload.Calendar },
                { displayName: 'Time zones', workloads: OwaWorkload.Calendar },
                { displayName: 'Holidays', workloads: OwaWorkload.Calendar },
                {
                    displayName: 'Interesting calendars and local events',
                    workloads: OwaWorkload.Calendar,
                },
                { displayName: 'Weather', workloads: OwaWorkload.Calendar },
                {
                    displayName: 'Adding or creating a new calendar',
                    workloads: OwaWorkload.Calendar,
                },
                {
                    displayName: 'Managing settings or appearance',
                    workloads: OwaWorkload.Calendar,
                },
                { displayName: 'Printing a calendar', workloads: OwaWorkload.Calendar },
                { displayName: 'Calendar search', workloads: OwaWorkload.Calendar },
                { displayName: 'Reminders or notifications', workloads: OwaWorkload.Calendar },
                { displayName: 'Other calendar', workloads: OwaWorkload.Calendar },
            ],
        },
        {
            displayName: 'Groups',
            baseEmailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'reactivegroups@service.microsoft.com',
            ],
            defaultWorkloads: OwaWorkload.Mail,
            subAreas: [
                {
                    displayName: 'Conversations',
                    additionalEmailAddresses: ['owagroupsfc@service.microsoft.com'],
                },
            ],
        },
        {
            displayName: 'People',
            baseEmailAddresses: ['outlookwebfeedback@microsoft.com'],
            defaultWorkloads: OwaWorkload.All,
            subAreas: [
                {
                    displayName: 'Profile Card',
                    additionalEmailAddresses: ['ProfileCardFeedback@service.microsoft.com'],
                },
                {
                    displayName: 'Profile Card - LinkedIn integration',
                    additionalEmailAddresses: ['fastopgrowth@service.microsoft.com'],
                },
                {
                    displayName: 'People Hub – Contact Management',
                    additionalEmailAddresses: ['Opfeedbackoc@service.microsoft.com'],
                },
                {
                    displayName: 'People Favorites',
                    additionalEmailAddresses: ['Opfeedbackoc@service.microsoft.com'],
                },
            ],
        },
        {
            displayName: 'Options',
            baseEmailAddresses: ['outlookwebfeedback@microsoft.com', 'owaframe@microsoft.com'],
            defaultWorkloads: OwaWorkload.All,
        },
        {
            displayName: 'Add-ins',
            baseEmailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'owaaddinsfeedback@microsoft.com',
            ],
            defaultWorkloads: OwaWorkload.All,
        },
        {
            displayName: 'Header',
            baseEmailAddresses: ['outlookwebfeedback@microsoft.com', 'owaframe@microsoft.com'],
            topLevelOnlyEmailAddresses: isFeatureEnabled('fwk-o365shellheader')
                ? ['o2shellteam@microsoft.com']
                : [],
            defaultWorkloads: OwaWorkload.All,
            subAreas: [
                {
                    displayName: 'Chat',
                    additionalEmailAddresses: [
                        'o2shellchat@microsoft.com',
                        'SkypeWebControlSWC@service.microsoft.com',
                    ],
                },
                {
                    displayName: 'Help',
                    additionalEmailAddresses: [
                        'o2shellhelp@microsoft.com',
                        'owahelppanefeedback@microsoft.com',
                    ],
                },
            ],
        },
        {
            displayName: 'To Do/Tasks',
            baseEmailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'olktaskfeedback@microsoft.com',
            ],
            defaultWorkloads: OwaWorkload.All,
        },
        isFeatureEnabled('cal-time-panel') && {
            displayName: 'Time Panel',
            baseEmailAddresses: [
                'outlookwebfeedback@microsoft.com',
                'calendarreactfeedback@service.microsoft.com',
                'timepanel@service.microsoft.com',
            ],
            defaultWorkloads: OwaWorkload.All,
        },
        // filter out any conditional feedback areas
    ].filter(feedbackArea => !!feedbackArea);

export default getFeedbackConfig;
